import type { ReactNode, RefObject } from "react";
import { Scroller } from "./Scrollers";

export interface ScrollableContainerViewProps {
  showLeftScroller?: boolean;
  showRightScroller?: boolean;
  scrollableContainerRef: RefObject<any>;
  leftHookRef: RefObject<HTMLDivElement>;
  rightHookRef: RefObject<HTMLDivElement>;
  children: ReactNode;
  id?: string;
}

export const ScrollableContainerView = ({
  showLeftScroller = false,
  showRightScroller = false,
  scrollableContainerRef,
  leftHookRef,
  rightHookRef,
  children,
  id = "scrollable-container-view",
}: ScrollableContainerViewProps) => (
  <div className="relative isolate grid" id={id}>
    {showLeftScroller && (
      <Scroller
        direction="left"
        scrollableContainerRef={scrollableContainerRef}
      />
    )}
    <div
      ref={scrollableContainerRef}
      className="bg-primary border-primary scrollbar-hide relative flex w-full items-center gap-1 overflow-x-scroll border-b px-6 lg:px-9"
    >
      <div className="-mx-1.5 min-h-[10px] min-w-[1px]" ref={leftHookRef} />
      {children}
      <div className="min-h-[10px] min-w-[10px]" ref={rightHookRef} />
    </div>
    {showRightScroller && (
      <Scroller
        direction="right"
        scrollableContainerRef={scrollableContainerRef}
      />
    )}
  </div>
);
